import { featuresHome } from "@/constants/home";
import FadeInSection from "../animations/FadeInSection";
import { useTranslation } from "react-i18next";

export default function StripFeature() {
    const { t } = useTranslation();
    return (
        <FadeInSection>
            <div className="bg-surface/10 dark:bg-dark border-2 border-gold/30 rounded-2xl mt-10 p-5 md:p-6 grid grid-cols-4 gap-2 md:gap-6">
                {featuresHome(t).map((f, i) => {
                    const Icon = f.icon;
                    return (
                        <div
                            key={`feature-home-${i}`}
                            className="flex flex-col justify-center md:flex-row md:justify-start items-center gap-3">
                            <Icon
                                className="text-gold"
                                size={28}
                            />
                            <div>
                                <div className="font-normal md:font-bold text-xs md:text-sm text-center md:text-left text-[#1A1208] dark:text-white">
                                    {f.title}
                                </div>
                                <div className="hidden md:flex md:text-xs text-gray-500">
                                    {f.subtitle}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </FadeInSection>
    );
}
